export default __webpack_public_path__ + "static/media/Group 1174.a6855db9.png";